import globalAxios from "../../../util/Api";
import { GET_LANDS_LIST, DELETE_LAND, CREATE_LAND, EDIT_LAND, START_LOADING, STOP_LOADING, LAND_ERROR } from "./types";
import { LogoutAction } from "../../../actions";

export const GetCountries = () => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/countries`)
      .then(res => {
        const newres = res.data.countries.map(obj => {
          obj['name'] = obj['country']
          delete obj['country']
          return obj
        })
        if (newres) {
          dispatch({ type: GET_LANDS_LIST, payload: newres })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}
export const CreateCountry = (branchName) => {
  let bodyFormData = new FormData();
  bodyFormData.append('country[country]', branchName);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().post(`/api/v1/countries`, bodyFormData)
      .then(res => {
        const newres = res.data.data
        newres['name'] = newres['country']
        delete newres['country']
        if (newres) {
          dispatch({ type: CREATE_LAND, payload: newres })
          dispatch(GetCountries())
        }
      }).catch(err => {
        if (err.response) {
          dispatch({ type: LAND_ERROR, payload: err.response.data.errors })
        }
      })
  }
}
export const EditCountry = (id, countryName) => {
  let bodyFormData = new FormData();
  bodyFormData.append('country[country]', countryName);

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().patch(`/api/v1/countries/${id}`, bodyFormData)
      .then(res => {
        const newres = res.data.data
        newres['name'] = newres['country']
        delete newres['country']
        if (newres) {
          dispatch({ type: EDIT_LAND, payload: newres })
          dispatch(GetCountries())
        }
      })
      .catch(err => {
        if (err.response) {
          dispatch({ type: LAND_ERROR, payload: err.response.data.errors })
        }
      })
  }
}
export const DeleteCountry = (id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().delete(`/api/v1/countries/${id}`)
      .then(res => {
        if (res) {
          dispatch({ type: DELETE_LAND })
          dispatch(GetCountries())
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: LAND_ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: LAND_ERROR, payload: err.message })
      })
  }
}
